(function(){
'use strict';
function offerProperties(quantity,is100){
 const count=is100 && Number.isInteger(Number(quantity)) ? Math.floor(Number(quantity)/2) : 0;
 return count>0 ? {'Free gift':`${count} × 50 ml of this same scent — pack at no extra charge`} : {};
}
if(typeof module!=='undefined')module.exports={offerProperties};
if(typeof document==='undefined')return;
function init(root){
 const box=root.querySelector('[data-quantity-offer]');if(!box||box.dataset.ready)return;box.dataset.ready='true';
 const form=root.querySelector('.luxury-pdp__form'),variant=form.querySelector('[name="id"]'),qty=form.querySelector('[name="quantity"]');
 const gift=box.querySelector('[data-offer-gift]'),add=box.querySelector('[data-offer-add]'),status=box.querySelector('[data-offer-status]');
 const money=cents=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:box.dataset.currency}).format(cents/100);
 const price=Number(box.dataset.offerPrice);
 box.querySelector('[data-offer-single-price]').textContent=money(price);
 box.querySelector('[data-offer-double-price]').textContent=money(price*2);
 let busy=false;
 const sync=()=>{
  const is100=variant.value===box.dataset.offerVariant,q=Number(qty.value),props=offerProperties(q,is100);
  gift.disabled=!props['Free gift'];gift.value=props['Free gift']||'';
  box.querySelectorAll('[data-offer-choice]').forEach(r=>{r.checked=is100&&Number(r.value)===q;r.closest('label').classList.toggle('is-selected',r.checked);});
  const dynamic=form.querySelector('.luxury-pdp__dynamic-checkout');if(dynamic)dynamic.hidden=!gift.disabled;
  add.disabled=busy||!!form.querySelector('[data-main-add]')?.disabled||!Number.isInteger(q)||q<1;
  add.textContent=busy?'Adding…':gift.disabled?'Add to bag':`Add ${q} × 100 ml + free gift to bag`;
 };
 box.addEventListener('change',e=>{if(!e.target.matches('[data-offer-choice]'))return;variant.value=box.dataset.offerVariant;qty.value=e.target.value;variant.dispatchEvent(new Event('change',{bubbles:true}));qty.dispatchEvent(new Event('change',{bubbles:true}));});
 form.addEventListener('change',sync);form.addEventListener('input',sync);
 add.addEventListener('click',()=>{sync();if(!add.disabled)form.requestSubmit(form.querySelector('[data-main-add]'));});
 form.addEventListener('submit',()=>{sync();});
 const checkout=async(e)=>{
  const button=e.target.closest('[data-buy-now],[data-sticky-buy-now]');if(!button||gift.disabled)return;
  e.preventDefault();e.stopImmediatePropagation();if(busy||button.disabled)return;
  status.textContent='';const original=button.textContent;busy=true;button.disabled=true;button.textContent='Redirecting…';sync();
  try{
   const route=window.Shopify?.routes?.root||'/';
   const response=await fetch(`${route}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variant.value),quantity:Number(qty.value),properties:offerProperties(Number(qty.value),variant.value===box.dataset.offerVariant)}]})});
   const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'Unable to add this bundle.');
   window.location.assign(`${route}checkout`);
  }catch(error){status.textContent=error.message||'Please try again.';}
  finally{busy=false;button.disabled=false;button.textContent=original;sync();}
 };
 document.addEventListener('click',checkout,true);
 new MutationObserver(sync).observe(form.querySelector('[data-main-add]'),{attributes:true,attributeFilter:['disabled']});
 box.hidden=false;sync();
}
const initAll=()=>document.querySelectorAll('[data-luxury-pdp]').forEach(init);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
document.addEventListener('shopify:section:load',initAll);
})();
